
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "68px",
    "height": "40px",
    "viewBox": "0 0 68 40",
    "enable-background": "new 0 0 68 40",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#999999",
        "width": "68",
        "height": "40"
      }
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M3.922,19.543h1.438v-3.188h1.063v3.188h1.5v1.047h-1.5v2.422c0.563-0.073,1.141-0.151,1.734-0.234\r\n\t\t\tc-0.052,0.396-0.089,0.755-0.109,1.078c-0.537,0.067-1.078,0.138-1.625,0.211v3.383H5.359v-3.242\r\n\t\t\tc-0.933,0.125-1.875,0.253-2.828,0.383l-0.125-1.141c0.942-0.089,1.927-0.192,2.953-0.313V20.59H2.766v-1.078\r\n\t\t\tc0.438-1.292,0.854-2.589,1.25-3.891h-1.5v-1.063h1.813c0.245-0.839,0.479-1.677,0.703-2.516l1.156,0.25\r\n\t\t\tc-0.234,0.766-0.466,1.521-0.695,2.266h2.242v1.063h-2.57C4.742,16.965,4.328,18.272,3.922,19.543z M8.078,13.871h4.359\r\n\t\t\tc-0.255-0.489-0.516-0.958-0.781-1.406l1.047-0.484c0.406,0.688,0.713,1.234,0.922,1.641l-0.531,0.25h4.453v2.078h-1.063v-1.078\r\n\t\t\tH9.141v1.078H8.078V13.871z M8.109,20.355h4.141v-1.094H8.766v-0.969h3.484V17.23H8.266v-0.969h3.984v-1h1.078v1h4v0.969h-4v1.063\r\n\t\t\th3.5v0.969h-3.5v1.094h4.156v0.969h-4.156v0.969H12.25v-0.969H8.109V20.355z M8.75,22.543h8.094v4.906h-1.063v-0.781H9.813v0.781\r\n\t\t\tH8.75V22.543z M15.781,23.512H9.813v2.188h5.969V23.512z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M19.703,13.246h13.438v1.219H21.031v10.906h12.359v1.188H19.703V13.246z M22.234,16.184l0.875-0.828\r\n\t\t\tc1.302,1.073,2.664,2.25,4.086,3.531c1.088-1.177,2.133-2.458,3.133-3.844l1.141,0.766c-1.094,1.417-2.203,2.729-3.328,3.938\r\n\t\t\tc1.297,1.183,2.641,2.448,4.031,3.797l-1.078,1.094c-1.261-1.317-2.558-2.62-3.891-3.906c-1.505,1.526-3.037,2.87-4.594,4.031\r\n\t\t\tc-0.25-0.323-0.583-0.661-1-1.016c1.635-1.114,3.19-2.414,4.664-3.898C24.966,18.613,23.62,17.392,22.234,16.184z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M39.172,16.59c-0.396-0.521-0.828-1.052-1.297-1.594l0.703-0.5h-1.344c-0.599,0.761-1.266,1.433-2,2.016\r\n\t\t\tc-0.208-0.25-0.469-0.542-0.781-0.875c1.219-0.948,2.213-2.141,2.984-3.578h1.344c-0.261,0.516-0.544,1.005-0.852,1.469h4.586\r\n\t\t\tv0.969h-3.75c0.469,0.453,0.911,0.917,1.328,1.391L39.172,16.59z M35.094,16.668h6.68c-0.183-0.328-0.404-0.692-0.664-1.094\r\n\t\t\tl1.078-0.469c0.344,0.5,0.656,1.021,0.938,1.563h6.172v2.422h-1.203v-1.406H36.297v1.422h-1.203V16.668z M36.859,18.84h9.625\r\n\t\t\tv3.766h-1.188v-0.391h-7.234v1.188h9.734v4.078h-1.188v-0.594h-8.547v0.609h-1.203V18.84z M45.297,19.777h-7.234v1.5h7.234V19.777\r\n\t\t\tz M46.609,24.34h-8.547v1.531h8.547V24.34z M46.313,16.574c-0.344-0.489-0.766-1.021-1.266-1.594l0.68-0.484h-1.32\r\n\t\t\tc-0.302,0.484-0.62,0.933-0.953,1.344c-0.229-0.229-0.547-0.484-0.953-0.766c0.729-0.813,1.338-1.817,1.828-3.016h1.344\r\n\t\t\tc-0.224,0.516-0.461,1.005-0.711,1.469h4.992v0.969h-4c0.474,0.458,0.901,0.917,1.281,1.375L46.313,16.574z"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M50.313,24.918c0.802-0.192,1.578-0.386,2.328-0.578v-4.734h-1.953v-1.094h1.953v-3.906h-2.109v-1.094\r\n\t\t\th5.375v1.094h-2.109v3.906h1.984v1.094h-1.984v4.422c0.688-0.192,1.354-0.386,2-0.578c0.052,0.469,0.109,0.875,0.172,1.219\r\n\t\t\tc-1.781,0.479-3.526,0.984-5.234,1.516L50.313,24.918z M55.281,25.84h4.891v-2.25h-3.984v-1.094h3.984v-2.063h-2.5v0.578h-1.156\r\n\t\t\tv-8.063h8.469v8.063h-1.156v-0.578h-2.5v2.063h3.984v1.094h-3.984v2.25H66v1.094H55.281V25.84z M57.672,16.168h2.5v-2.156h-2.5\r\n\t\t\tV16.168z M57.672,19.371h2.5v-2.172h-2.5V19.371z M63.828,14.012h-2.5v2.156h2.5V14.012z M61.328,19.371h2.5v-2.172h-2.5V19.371z"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  